// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1swXg","clinicsSelect":"styles_clinicsSelect__19iTQ"};